'use client';
import { jsx } from 'react/jsx-runtime';
import { factory, useProps, Box, rem } from '@mantine/core';
import { useRichTextEditorContext } from '../RichTextEditor.context.mjs';
import classes from '../RichTextEditor.module.css.mjs';

const defaultProps = {};
const RichTextEditorToolbar = factory((_props, ref) => {
  const props = useProps("RichTextEditorToolbar", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    vars,
    sticky,
    stickyOffset,
    mod,
    variant,
    ...others
  } = props;
  const ctx = useRichTextEditorContext();
  return /* @__PURE__ */ jsx(
    Box,
    {
      ref,
      mod: [{ sticky }, mod],
      variant: variant || ctx.variant,
      ...ctx.getStyles("toolbar", { className, style, styles, classNames }),
      ...others,
      __vars: { "--rte-sticky-offset": rem(stickyOffset) }
    }
  );
});
RichTextEditorToolbar.classes = classes;
RichTextEditorToolbar.displayName = "@mantine/tiptap/RichTextEditorToolbar";

export { RichTextEditorToolbar };
//# sourceMappingURL=RichTextEditorToolbar.mjs.map
